import React from 'react';

export default function UpcomingBirthdaysWidget({ birthdays = [] }) {
  const getInitials = (name) => {
    if (!name) return 'EM';
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .slice(0, 2)
      .toUpperCase();
  };

  const getCountdownChip = (daysUntil) => {
    if (daysUntil === 0) {
      return (
        <span className="rounded-full bg-rose-500 text-white px-2.5 py-0.5 text-[10px] font-extrabold shadow-xs animate-pulse">
          Today! 🎂
        </span>
      );
    }
    if (daysUntil === 1) {
      return (
        <span className="rounded-full bg-amber-500 text-white px-2 py-0.5 text-[10px] font-bold">
          Tomorrow
        </span>
      );
    }
    return (
      <span className="rounded-full bg-surface-container-high text-slate-600 px-2 py-0.5 text-[10px] font-bold">
        In {daysUntil} days
      </span>
    );
  };

  return (
    <div className="flex flex-col rounded-3xl border border-outline-variant/25 bg-surface p-6 shadow-xs">
      <div className="flex items-center justify-between border-b border-outline-variant/15 pb-4">
        <div className="flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-rose-500/10 text-rose-600">
            <span className="material-symbols-outlined text-xl">cake</span>
          </div>
          <div>
            <h3 className="text-sm font-bold text-on-surface">Upcoming Birthdays</h3>
            <p className="text-[11px] text-slate-500">Colleague celebrations</p>
          </div>
        </div>
        <span className="rounded-lg bg-surface-container-high px-2 py-0.5 text-[11px] font-bold text-slate-600">
          {birthdays.length} Upcoming
        </span>
      </div>

      <div className="mt-4 flex-1 space-y-2.5 overflow-y-auto max-h-[320px] pr-1">
        {birthdays.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-8 text-center">
            <span className="material-symbols-outlined text-3xl text-slate-300">celebration</span>
            <p className="mt-2 text-xs font-semibold text-slate-500">No birthdays this month</p>
            <span className="text-[11px] text-slate-400">All colleague birthdays are up to date!</span>
          </div>
        ) : (
          birthdays.map((item, idx) => (
            <div
              key={item.id || item.AcHeadID || idx}
              className="flex items-center justify-between rounded-2xl border border-outline-variant/20 bg-surface-container-lowest p-3 transition hover:bg-surface-container-low"
            >
              <div className="flex items-center gap-3 min-w-0">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-tr from-rose-500/20 to-amber-500/20 text-rose-700 font-extrabold text-xs">
                  {item.profile_photo_path ? (
                    <img
                      src={item.profile_photo_path}
                      alt={item.Name}
                      className="h-full w-full rounded-xl object-cover"
                    />
                  ) : (
                    <span>{getInitials(item.Name)}</span>
                  )}
                </div>

                <div className="min-w-0">
                  <h4 className="text-xs font-bold text-on-surface truncate">{item.Name}</h4>
                  <div className="flex items-center gap-1.5 text-[11px] text-slate-500">
                    <span>{item.department || 'General'}</span>
                    <span>•</span>
                    <span className="font-mono">{item.BirthDate1 || item.date}</span>
                  </div>
                </div>
              </div>

              <div className="shrink-0 flex items-center gap-2">
                {getCountdownChip(item.daysUntil ?? item.days_until ?? 0)}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
